import { render, staticRenderFns } from "./QuizActivity.vue?vue&type=template&id=b425c672&"
import script from "./QuizActivity.vue?vue&type=script&lang=js&"
export * from "./QuizActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports